<div class="heat" data-testid="risk-heat-map">
  <div class="label section-label">Risk map · open risks</div>
  <div class="grid">
    <div class="axis-title-y">Impact</div>
    @for (row of rows; track row[0].impact) {
      <div class="axis-y">{{ row[0].impact }}</div>
      @for (cell of row; track cell.probability) {
        <button
          type="button"
          class="cell bg-{{ cell.band }} txt-{{ cell.band }}"
          [class.empty]="!cell.count"
          [class.picked]="cell.selected"
          [attr.data-testid]="'heat-cell-' + cell.probability + '-' + cell.impact"
          (click)="toggle(cell)">
          {{ cell.count }}
        </button>
      }
    }
    <div></div><div></div>
    @for (p of probabilities; track p) { <div class="axis-x">{{ p }}</div> }
    <div></div><div></div>
    <div class="axis-x span">Probability</div>
  </div>
</div>
